module.exports = __webpack_public_path__ + "static/media/viasat-xtra-3.b01d1268.png";